"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditorialInfo = void 0;
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const EditorialInfo = (param)=>{
    let { authorName, publishedDate, photographerName } = param;
    const { translations } = (0, _hooks.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    const formattedPublishedDate = (0, _culture.useFormatDate)(new Date(publishedDate !== null && publishedDate !== void 0 ? publishedDate : ''), _culture.DateFormat.ShortDate, {
        toLocalTimezone: true
    });
    if (!publishedDate && !authorName && !photographerName) {
        return null;
    }
    const editorialInfo = [
        publishedDate ? "".concat(translations.published, ":\xa0").concat(formattedPublishedDate) : null,
        authorName ? "".concat(translations.author, ":\xa0").concat(authorName) : null,
        photographerName ? "".concat(translations.photo, ":\xa0").concat(photographerName) : null
    ].filter(Boolean).join('  |  ');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        "data-testid": getTestId(_constants.EDITORIAL_INFO),
        children: editorialInfo
    });
};
exports.EditorialInfo = EditorialInfo;
